export const CREATE_NEW_USER = "CREATE_NEW_USER";
export const SET_CURRENT_USER = "SET_CURRENT_USER"
export const REMOVE_USER = 'REMOVE_USER'
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER'; 
export const ADD_ORDER_ID = "ADD_ORDER_ID";
